import React from "react"
import { GenericMarkdown } from "../GenericMarkdown"

type Props = {
  keyBenefits: string
}

export const KeyBenefits: React.FC<Props> = ({ keyBenefits }) => {
  return <GenericMarkdown content={keyBenefits} />
}
